import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconPencil = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.058 2.942a3.233 3.233 0 0 0-4.595.032L3.574 15.862 2 22l6.138-1.574L21.026 7.537a3.235 3.235 0 0 0 .032-4.595"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16 3 5 5M4 16l4 4"
    />
  </NcIcon>
);
export { NcIconPencil };
